import { Route, Routes } from "react-router-dom";

import React from "react";
import { ClassesRoutes } from "./ClassesRoutes";

export const SchoolRoutes = () => {
  return (
    <Routes>
      <Route path="classes/*" element={<ClassesRoutes />} />
    </Routes>
  );
};
